import { CustomFieldType, FieldDefinition } from '@lopo-tech/lopo-api'
import React from 'react'
import InputDatePicker from 'src/components/forms/input_date_picker/input_date_picker'
import InputField from 'src/components/forms/input_field/input_field'

type Props = {
  disabled?: boolean;
  errorText?: string;
  fieldType: FieldDefinition['fieldType'];
  label: string;
  name: string;
  required: boolean;
  value?: string;
  setValue?: (value: string) => void;
};

export const ReportFormInput: React.FC<Props> = ({
  disabled,
  errorText,
  fieldType,
  label,
  name,
  required,
  value,
  setValue
}) => {
  switch (fieldType) {
    case CustomFieldType.Text:
      return (
        <InputField
          name={name}
          label={label}
          required={required}
          value={value ?? ''}
          onChange={setValue}
          disabled={disabled}
          floatLabel={false}
          errorText={errorText}
          valid={!errorText}
        />
      )
    case CustomFieldType.Textarea:
      return (
        <InputField
          name={name}
          label={label}
          required={required}
          value={value ?? ''}
          onChange={setValue}
          disabled={disabled}
          initialRows={3}
          floatLabel={false}
          valid={!errorText}
        />
      )
    case CustomFieldType.Date:
      return (
        <InputDatePicker
          name={name}
          label={label}
          required={required}
          value={value ?? ''}
          onChange={setValue}
          disabled={disabled}
          floatLabel={false}
          valid={!errorText}
        />
      )
    case CustomFieldType.Number:
      return (
        <InputField
          name={name}
          label={label}
          required={required}
          value={value ?? ''}
          onChange={setValue}
          disabled={disabled}
          type="number"
          floatLabel={false}
          valid={!errorText}
        />
      )
  }
}
